import React from "react";
import { categoryDropdown } from "../../../../data/categoryDropdown";
import ViewMore from "../Common/ViewMore";
import Category from "./Category";

const Categories = () => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-2 py-8">
      <p className="mb-3 font-pop text-base font-bold uppercase">Categories</p>
      <div className="flex flex-col gap-4 px-2">
        {categoryDropdown.map((category) => (
          <Category key={category.id} category={category} />
        ))}
        <ViewMore />
      </div>
    </div>
  );
};

export default Categories;
